module.exports = {"domain":"nowyu.eu.auth0.com","clientId":"dQ1UkbUDa1dT3tJZBw0vGFCKFoAx05kI","callbackUrl":"https://me.nowyu.com/login/callback","audience":"api.nowyu.com","responseType":"token id_token","scope":"openid email profile"}


//////////////////
// WEBPACK FOOTER
// ./src/store/auth0.json
// module id = 348
// module chunks = 2